import { isRejectedWithValue } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reset } from "../auth/authSlice";

const SIGNOUT_URL = process.env.REACT_APP_SIGNOUT_URL;
const API_URL = process.env.REACT_APP_API_URL;
const SUBSCRIPTION_KEY = process.env.REACT_APP_SUBSCRIPTION_KEY;
const UNAUTHORIZED_STATUSES = [401, 403];

const prepareHeaders = (headers, { getState }) => {
  const token = getState().auth.token;

  headers.set("ocp-apim-subscription-key", SUBSCRIPTION_KEY);
  token && headers.set("authorization", `Bearer ${token}`);
  return headers;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders,
  }),
  keepUnusedDataFor: 3600, // 1 hour
  tagTypes: ["Voucher", "Appointment", "Doctor", "User"],
  endpoints: () => ({}),
});

export const errorHandler = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    if (
      UNAUTHORIZED_STATUSES.includes(action.payload.status) &&
      api.getState().auth.token !== undefined
    ) {
      api.dispatch(reset());
      window.location.replace(SIGNOUT_URL);
    } else {
      console.warn(action.payload);
    }
  }

  return next(action);
};
